
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TimeSelector from '@/views/dashboard/_components/group-policy-settings/_components/mix-selectors/time-selector.vue'
import { ElMessage } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  GroupPolicySettingsService,
  TaskTimeSetting
} from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
export default defineComponent({
  components: {
    TimeSelector
  },
  props: {
    mixType: {
      type: Number,
      default: 1
    },
    mainSwitch: {
      type: Boolean,
      default: false
    },
    sKey: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([])
    const service = injector.get(GroupPolicySettingsService)
    const data = reactive({
      count: 1,
      selectorsValue: [{ target: 1, start_min: 0, end_min: 10 }] as TaskTimeSetting[]
    })
    service[props.sKey].subscribe((stategy: any) => {
      data.selectorsValue = stategy
    })
    return {
      ...toRefs(data),
      addSelector () {
        if (!props.mainSwitch) {
          return
        }
        // eslint-disable-next-line no-magic-numbers
        if (data.selectorsValue.length === 5) {
          ElMessage.error(t('groupPolicySettings.mixSelMaxFiveTasks'))
          return
        }
        service.updateEditTab(true)
        data.selectorsValue.push({ target: 1, start_min: 0, end_min: 10 })
        service.updateSelectors(props.sKey, data.selectorsValue)
      },
      subSelector (idx: number) {
        if (!props.mainSwitch) {
          return
        }
        if (data.selectorsValue.length === 1) {
          ElMessage.error(t('groupPolicySettings.mixSelKeepOneTask'))
          return
        }
        service.updateEditTab(true)
        data.selectorsValue.splice(idx, 1)
        service.updateSelectors(props.sKey, data.selectorsValue)
      }
    }
  }
})
